export const kickoffDate = 'March 7, 2026';
export const hackathonDate = 'March 21-22, 2026';
